import { DateObject } from "react-multi-date-picker";

export const fromDateObjectToDate = (dateObject: DateObject) : Date => {
    return dateObject.toDate()
}

export const fromDateToDateObject = (date: Date) : DateObject => {
    return new DateObject(date)
}

export function handleChangeDateObject(e: any, setDate: React.Dispatch<React.SetStateAction<Date>>) {
    if(e instanceof DateObject){
        setDate(fromDateObjectToDate(e));
    }
}
